export default __webpack_public_path__ + "static/media/document.2c034aa2.png";